module.exports = __webpack_public_path__ + "img/lordsmobile_guide_de.a162985.png";